import { Injectable } from '@angular/core';
import { BaseEnumService } from '@fleet-beat/core';

export const enum EditorSpecialItemType {
  Title = 'title',
  Array = 'array',
  Editor = 'editor',
  Gap = 'gap',
  Column = 'column',
  Content = 'templated-content',
}

@Injectable({
  providedIn: 'root',
})
export class EditorSpecialItemTypeEnumService extends BaseEnumService<EditorSpecialItemType> {
  protected override readonly data: Record<string, EditorSpecialItemType> = {
    Title: EditorSpecialItemType.Title,
    Array: EditorSpecialItemType.Array,
    Column: EditorSpecialItemType.Column,
    Content: EditorSpecialItemType.Content,
    Editor: EditorSpecialItemType.Editor,
  };
}
